module.exports = __webpack_public_path__ + "static/Verne5-9a757365f6d0fddf868c49f9e73e84e6.png";